// A scheduled prompt's feed, as the chat shows it: every stored answer becomes one dated entry
// (the response text with its chart and table placeholders appended, the structured charts
// and tables beside it). The Scheduled Tasks list opens the feed on its latest page, and
// useScheduledFeedPaging reads the older pages as the reader scrolls up — both parse an
// answer through `parseScheduledResponse`, so an older page looks exactly like the first.

export function convertKeysToLowercase(obj) {
  if (Array.isArray(obj)) {
    return obj.map(convertKeysToLowercase);
  } else if (obj !== null && typeof obj === "object") {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      acc[key.toLowerCase()] = convertKeysToLowercase(value);
      return acc;
    }, {});
  }
  return obj;
}

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${date.getFullYear()}`;
};

// One stored answer ({ scheduledResponse, resources } as the API sends it) → one chat entry.
export function parseScheduledResponse(response) {
  const { response: incomingResponse, question: incomingQuestion } =
    convertKeysToLowercase(response.scheduledResponse.response).flat()[0];

  const charts = [];
  const tables = [];

  (response.resources ?? []).forEach((res) => {
    (res.tableContent ?? []).forEach((tablecontent) => {
      const data = JSON.parse(tablecontent.Data);
      if (data && data.type === "chart") {
        charts.push(data);
      } else if (data && data.type === "table") {
        tables.push(data);
      }
    });
  });

  let dynamicResponse = incomingResponse;
  charts.forEach((chart, chartIndex) => {
    dynamicResponse += `\n\n{{CHART:${chartIndex}}}\n\n`;
  });
  tables.forEach((table, tableIndex) => {
    dynamicResponse += `\n\n{{TABLE:${tableIndex}}}\n\n`;
  });

  return {
    id: response.scheduledResponse.id,
    response: dynamicResponse,
    question: incomingQuestion,
    charts,
    tables,
    date: formatDate(response.scheduledResponse.createDateUTC),
  };
}

// The page the list holds (the latest answers, oldest first) as chat entries.
export function parseToHistoryResponse(item) {
  return (item.scheduledResponses ?? []).map(parseScheduledResponse);
}

// What the chat needs to page further back: which prompt, whether older answers exist, and
// the oldest one on screen (the cursor of the next page).
export function scheduledFeedMeta(item, entries) {
  return {
    questionId: item.scheduledQuestion.id,
    hasMore: item.hasMoreResponses === true,
    oldestId: entries.length > 0 ? entries[0].id ?? null : null,
  };
}
